import {
  Button,
  Input,
  Text,
  HStack,
  Flex,
  Box,
  useBreakpointValue,
  Spinner,
  ModalFooter,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Tooltip,
  Divider,
} from "@chakra-ui/react";
import { useState, useEffect, useContext, useRef } from "react";
import {
  addMedicinesKeyAndCleanFields,
  exportToExcel,
  exportToExcels,
  handleSaveAllPages,
  swapAndCompare,
  transformToinitialOrgAndEditedFormat,
  updateOriginalValues,
} from "../fields/utils/functions";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsRight,
  FiDownload,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { MdEmail } from "react-icons/md";
import CommentDrawer from "../CommentDrawer/CommentDrawer";
import { clone } from "lodash";
import DynamicForm from "../fields/DynamicForm";

const FieldsModal = ({
  file,
  getData,
  isDisabled = false,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  name,
  open,
  close,
  values,
  data,
}: any) => {
  const [datas, setDatas] = useState({ ...data });
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [deletedDataIndex, setDeletedDataIndex] = useState([]);
  const [finalResults, setFinalResults] = useState<any>([]);
  const fieldRef = useRef<any>(null);

  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [inputValue, setInputValue] = useState(currentPage.toString());
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fetchedFiles, setFetchedFiles] = useState<any[]>([]);

  function transformAdditionalFiles(datas: any) {
    if (!Array.isArray(datas.additionalFiles)) return datas;

    const detailedAdditionalFiles = datas.additionalFiles.map(
      (fileRef: any) => {
        const [key, id] = Object.entries(fileRef)[0];
        const fileData = datas[key]?.[0];
        return fileData ? fileData : { _id: id };
      }
    );

    datas.additionalFiles = detailedAdditionalFiles;

    return datas;
  }

  useEffect(() => {
    if (Array.isArray(values)) {
      if (Array.isArray(values[values.length - 1].values?.results)) {
        setTotalPages(values[values.length - 1].values?.results?.length || 0);
        const transformed: any = values[values.length - 1].values?.results.map(
          (result: any) => {
            return updateOriginalValues(result);
          }
        );
        setTransformedData(transformed);
      }
    } else {
      setTotalPages(values?.values?.results?.length || 0);
      if (Array.isArray(values?.values?.results)) {
        const transformed = values?.values?.results.map((result: any) => {
          return transformToinitialOrgAndEditedFormat(result?.fields);
        });
        setTransformedData(transformed);
      }
    }
  }, []);

  useEffect(() => {
    if (open && datas) {
      let dats: any = {};
      dats = transformAdditionalFiles(datas);
      const fetchAllFiles = async () => {
        const results = await Promise.all(
          dats.additionalFiles.map(async (fileObj: any) => {
            return await getFile(fileObj);
          })
        );

        setFetchedFiles(results.filter((file) => file !== null));
      };
      fetchAllFiles();
    }
  }, [open, datas]);
  const handleFormDataChange = (pageData: any) => {
    setTransformedData((prevData) => {
      const newData = [...prevData];
      newData[currentPage - 1] = pageData;
      return newData;
    });
  };

  const handleSaveFromParent = () => {
    if (fieldRef.current) {
      const savedData = fieldRef.current.save;
      setFinalResults(transformedData);
    }
  };

  const getFile = async (fileId: any) => {
    try {
      if (fileId?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: fileId?._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: fileId?.metadata?.contentType })
            );
            return {
              url: fileURL,
              file: fileId,
              type: fileId?.metadata?.contentType,
              buffer: buffer,
            };
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width = "98vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  const getValue = (field: any): string => {
    if (Array.isArray(field)) {
      const values = field.map((item: any) => {
        if (typeof item === "object" && item !== null) {
          if (item.editedValues) {
            return item.editedValues;
          }
          if (item.originalValues) {
            return item.originalValues;
          }
        }
        return "";
      });

      return JSON.stringify(values);
    }

    if (typeof field === "object" && field !== null) {
      if (field.editedValues) {
        return field.editedValues;
      }
      if (field.originalValues) {
        return field.originalValues;
      }
      return "";
    }
    return field || "";
  };

  return (
    <>
      <Drawer
        isOpen={open}
        onClose={() => {
          close();
          setDatas(null);
        }}
        size="full"
      >
        <DrawerOverlay bg="rgba(0, 0, 0, 0.2)" />
        <DrawerContent
          // position="fixed"
          // right={isOpen ? "0" : `-${width}`}
          // top="0"
          // height="100vh"
          // width={viewerWidth ? width : "100vw"}
          // animation={`${
          //   isOpen ? "slideIn" : "slideOut"
          // } 0.8s ease-in-out forwards`}
          style={{ width: "98vw" }}
        >
          <DrawerHeader
            fontSize={{ base: "md", lg: "lg" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem"
            ml="1rem"
          >
            Document
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody
            px={{ base: ".5rem", lg: "1.5rem" }}
            py=".2rem"
            overflowY="auto"
            className="customScrollBar"
            mb={{ base: "1rem", lg: "unset" }}
          >
            <Box
              display={{ base: "grid", lg: "flex" }}
              flexDirection={{ base: "column", lg: "row" }}
              gap={{ base: 1, lg: 6 }}
              h="100%"
            >
              {fetchFileLoader ? (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                  mb="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color="teal.400"
                  />
                </Box>
              ) : (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                  w={{ lg: "80vw" }}
                >
                  <Box width="100%">
                    <Text fontWeight="bold" mt={4} mb={2}>
                      Signatures :
                    </Text>
                    <Divider />
                    <Flex gap={5} justifyContent="space-around">
                      {fetchedFiles.map((file, index) => {
                        return (
                          <Box key={file?.id} mb={4}>
                            <Text fontSize="sm" fontWeight="bold" mb={4} mt={4}>
                              File {index + 1}:{" "}
                              {file?.file?.filename || "Unknown File"}
                            </Text>
                            {file && <FileViewer sample={file} />}
                          </Box>
                        );
                      })}
                    </Flex>
                  </Box>{" "}
                </Box>
              )}

              <Box>
                {transformedData && (
                  <Box
                    h={!isDisabled ? "85vh" : "85vh"}
                    w={{ base: "100%", lg: "25vw" }}
                    p={{ base: "0.8rem", lg: "1rem" }}
                    overflowY="auto"
                    className="customScrollBar"
                    onWheel={handleModalWheel}
                    border="1px solid"
                    borderColor="teal.500"
                    borderRadius="md"
                    boxShadow="sm"
                    mb={4}
                    background="white"
                  >
                    <Text fontWeight="bold">Values</Text>
                    <Divider mb={3} mt={2} />
                    {transformedData[currentPage - 1] ? (
                      <DynamicForm
                        data={transformedData[currentPage - 1]}
                        // onSubmit={() => {}}
                        onDataChange={handleFormDataChange}
                        ref={fieldRef}
                        accountDetails={accountDetails}
                        workFlowData={workFlowData}
                        // name={name}
                        // setDeletedDataIndex={setDeletedDataIndex}
                      />
                    ) : (
                      <Text fontSize="md" color="gray.600" textAlign="center">
                        No data available for this page.
                      </Text>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </DrawerBody>
          {!isDisabled &&
            accountDetails.role !== "admin" &&
            name === "Pending Approval" &&
            ["approver", "uploader"].includes(accountDetails?.role) && (
              <ModalFooter p="0.5rem">
                <Flex>
                  {!isDisabled &&
                    accountDetails.role !== "admin" &&
                    name === "Pending Approval" &&
                    ["approver", "uploader"].includes(accountDetails?.role) && (
                      <Box>
                        <Button
                          onClick={() => {
                            // handleDocUpdate('approved',level,id)
                            handleSaveFromParent();
                            setCommentModel({
                              open: true,
                              selectedStatus: "approved",
                              comment: "",
                              isMulti: false,
                            });
                          }}
                          fontSize="sm"
                          bg="green.500"
                          color="white"
                          _hover={{ bg: "green.600" }}
                          mr="1rem"
                          w="100px"
                        >
                          Accept
                        </Button>
                        <Button
                          onClick={() => {
                            handleSaveFromParent();
                            setCommentModel({
                              open: true,
                              selectedStatus: "rejected",
                              comment: "",
                              isMulti: false,
                            });
                          }}
                          bg="red.500"
                          _hover={{ bg: "red.600" }}
                          color="white"
                          w="100px"
                          mr="14px"
                        >
                          Reject
                        </Button>
                      </Box>
                    )}{" "}
                </Flex>
              </ModalFooter>
            )}
        </DrawerContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
        <CommentDrawer
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          editedValues={{ results: transformedData }}
          setCommentModel={setCommentModel}
          handleGet={getData}
          view={true}
          isOpen={commentModel.open}
          width={width}
          onClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          handleClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          selectedFile={file}
        />
      </Drawer>
    </>
  );
};

export default FieldsModal;
